export default {"src":"/_next/static/media/AER_LINGUS.73cdd567.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};